import React, { useEffect, useState } from "react";
import client, { apiErr } from "../../lib/api";
import { Panel } from "../ui-kit";
import { toast } from "sonner";
import { Pause, Play, Send, Save } from "lucide-react";
import { Empty } from "../team/shared";

const box = "bg-[color:var(--app-bg)] border border-[color:var(--border-subtle)] px-2 py-1.5 text-sm text-white font-mono focus:border-gold focus:outline-none";

function Row({ m, effPct, onSaved }) {
  const [share, setShare] = useState(m.lead_share ?? "");
  const [tg, setTg] = useState(m.telegram_chat_id || "");
  useEffect(() => { setShare(m.lead_share ?? ""); setTg(m.telegram_chat_id || ""); }, [m.lead_share, m.telegram_chat_id]);
  const patch = async (body, msg) => {
    try { await client.patch(`/partners/${m.id}`, body); toast.success(msg); onSaved(); } catch (e) { toast.error(apiErr(e)); }
  };
  const save = () => patch({ lead_share: share === "" ? -1 : Number(share), telegram_chat_id: tg.trim() }, "Saved");
  const test = async () => {
    try { await client.post(`/partners/${m.id}/telegram-test`); toast.success("Test message sent"); } catch (e) { toast.error(apiErr(e)); }
  };
  const off = !m.active || m.leads_paused || effPct === 0;
  return (
    <tr data-testid={`dist-row-${m.id}`} className="border-t border-[color:var(--border-subtle)]">
      <td className="px-3 py-2.5">
        <div className={off ? "text-slate-500" : "text-white"}>{m.name}</div>
        <div className={`text-[10px] uppercase tracking-wider ${off ? "text-amber-400" : "text-bull"}`}>{!m.active ? "Disabled" : m.leads_paused ? "Paused" : effPct === 0 ? "No leads" : `Gets ~${effPct}%`}</div>
      </td>
      <td className="px-3 py-2.5"><input data-testid={`dist-share-${m.id}`} type="number" min="0" max="100" value={share} placeholder="equal" onChange={(e) => setShare(e.target.value)} className={`${box} w-20`} /></td>
      <td className="px-3 py-2.5">
        <input data-testid={`dist-tg-${m.id}`} value={tg} placeholder="Chat ID e.g. 123456789" onChange={(e) => setTg(e.target.value.replace(/[^\d-]/g, ""))} className={`${box} w-44`} />
      </td>
      <td className="px-3 py-2.5 whitespace-nowrap space-x-1.5">
        <button data-testid={`dist-save-${m.id}`} onClick={save} className="btn-gold px-2.5 py-1.5 text-xs inline-flex items-center gap-1"><Save size={12} />Save</button>
        <button data-testid={`dist-test-${m.id}`} onClick={test} disabled={!m.telegram_chat_id} className="px-2.5 py-1.5 text-xs border border-[#2AABEE] text-[#2AABEE] inline-flex items-center gap-1 disabled:opacity-40"><Send size={12} />Test</button>
        <button data-testid={`dist-pause-${m.id}`} onClick={() => patch({ leads_paused: !m.leads_paused }, m.leads_paused ? "Resumed" : "Paused")}
          className={`px-2.5 py-1.5 text-xs border inline-flex items-center gap-1 ${m.leads_paused ? "border-bull text-bull" : "border-amber-500 text-amber-400"}`}>
          {m.leads_paused ? <><Play size={12} />Resume</> : <><Pause size={12} />Pause</>}
        </button>
      </td>
    </tr>
  );
}

export function LeadDistribution({ members, onChange }) {
  const live = members.filter((m) => m.active && !m.leads_paused);
  const eq = live.length ? 100 / live.length : 0;
  const w = (m) => (m.lead_share == null ? eq : Number(m.lead_share));
  const sum = live.reduce((a, m) => a + w(m), 0);
  const eff = (m) => (sum ? Math.round((w(m) / sum) * 100) : 0);
  return (
    <Panel title="Lead Distribution" testid="lead-distribution-panel">
      {members.length === 0 ? <Empty text="No partners yet." /> : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead><tr className="text-[11px] uppercase tracking-widest text-slate-500 text-left">
              {["Agent", "Lead share %", "Telegram Chat ID", ""].map((h) => <th key={h} className="px-3 py-2 font-normal">{h}</th>)}
            </tr></thead>
            <tbody>{members.map((m) => <Row key={m.id} m={m} effPct={eff(m)} onSaved={onChange} />)}</tbody>
          </table>
          <p className="px-3 py-2 text-[11px] text-slate-500" data-testid="dist-help">
            Google Sheet aur CSV upload ki "Auto" leads isi % me baantengi (total {Math.round(sum)}% — 100 na ho to bhi anupaat se baantega). 0% ya Paused agent ko koi lead nahi jayegi; khaali box = 100 ÷ active agents. Koi bhi % / pause badalte hi naya split usi waqt se lagu hota hai.
            Chat ID: agent bot ko /start bheje, phir @userinfobot se apna ID lekar yahan daalein — ya agent portal me "Connect Telegram" dabaye.
          </p>
        </div>
      )}
    </Panel>
  );
}
